import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle, ArrowRight } from "lucide-react";
import {
  CompleteMobileCheckout,
  GetMobileCheckout,
} from "../services/api_mobile_checkout";

const MobileCheckoutSuccess = () => {
  const [searchParams] = useSearchParams();
  const checkoutId = searchParams.get("id");

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!checkoutId) {
      setError("Invalid checkout.");
      setLoading(false);
      return;
    }

    CompleteMobileCheckout(checkoutId, {
      onSuccess: () => {
        GetMobileCheckout(checkoutId, {
          onSuccess: (response) => {
            setData(response);
            setLoading(false);
          },
          onError: (err) => {
            setError(err);
            setLoading(false);
          },
        });
      },
      onError: (err) => {
        setError(err);
        setLoading(false);
      },
    });
  }, [checkoutId]);

  const handleOpenInApp = () => {
    if (data?.returnUrl) {
      window.location.href = data.returnUrl;
      return;
    }
    alert("Please return to the SkillBakery mobile app.");
    window.close();
  };

  // ==================== LOADING ====================
  if (loading) {
    return (
      <div className="min-vh-100 position-relative overflow-hidden" style={{ background: "#0a0a0f" }}>
        <img src="./images/giphy-new.gif" alt="background" className="position-absolute w-100 h-100 object-fit-cover" style={{ opacity: 0.45 }} />
        <div className="position-absolute w-100 h-100" style={{ background: "rgba(0,0,0,0.6)" }}></div>
        <div className="position-relative d-flex align-items-center justify-content-center min-vh-100">
          <div className="text-center text-white">
            <div className="spinner-border text-light mb-4" style={{ width: "3rem", height: "3rem" }}></div>
            <h4>Finalizing your purchase...</h4>
          </div>
        </div>
      </div>
    );
  }

  // ==================== ERROR ====================
  if (error) {
    return (
      <div className="min-vh-100 position-relative overflow-hidden" style={{ background: "#0a0a0f" }}>
        <img src="./images/giphy-new.gif" alt="background" className="position-absolute w-100 h-100 object-fit-cover" style={{ opacity: 0.45 }} />
        <div className="position-absolute w-100 h-100" style={{ background: "rgba(0,0,0,0.6)" }}></div>
        <div className="position-relative d-flex align-items-center justify-content-center min-vh-100 px-3">
          <div className="card shadow border-0 text-center" style={{ maxWidth: "420px", borderRadius: "20px" }}>
            <div className="card-body p-5">
              <h4 className="text-danger">Payment Issue</h4>
              <p className="text-muted">{error}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ==================== SUCCESS ====================
  return (
    <div className="min-vh-100 position-relative overflow-hidden" style={{ background: "#0a0a0f" }}>
      <img src="./images/giphy-new.gif" alt="background" className="position-absolute w-100 h-100 object-fit-cover" style={{ opacity: 0.45 }} />
      <div className="position-absolute w-100 h-100" style={{ background: "rgba(0,0,0,0.6)" }}></div>

      <div className="position-relative py-5 px-3">
        <div className="container" style={{ maxWidth: "620px" }}>
          <div className="card shadow-lg border-0" style={{ borderRadius: "24px", overflow: "hidden" }}>
            
            {/* Accent Bar */}
            <div style={{ height: "6px", background: "linear-gradient(to right, #10b981, #34d399)" }}></div>

            <div className="card-body p-5 text-center">
              <CheckCircle className="mx-auto text-success mb-4" size={72} />

              <h2 className="fw-bold mb-2">Payment Successful!</h2>
              <p className="text-muted fs-5 mb-5">Thank you for your purchase on SkillBakery.</p>

              {/* Purchased Items */}
              {data?.items && data.items.length > 0 && (
                <div className="card bg-light border mb-5 text-start">
                  <div className="card-body p-4">
                    <h6 className="fw-bold mb-3">What you purchased:</h6>
                    {data.items.map((item, index) => (
                      <div key={index} className="d-flex justify-content-between py-2 border-bottom">
                        <span>{item.title || item.Title}</span>
                        <span className="fw-semibold">
                          {item.currency || item.Currency} {item.price || item.Price}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <button
                onClick={handleOpenInApp}
                className="btn btn-lg w-100 d-flex align-items-center justify-content-center gap-2"
                style={{ 
                  backgroundColor: "#6366f1", 
                  color: "white", 
                  borderRadius: "14px", 
                  height: "58px",
                  maxWidth: "360px",
                  margin: "0 auto"
                }}
              >
                Open in SkillBakery App <ArrowRight size={20} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileCheckoutSuccess;